import { useNavigate } from 'react-router-dom';
import { TableColumn } from '../../components/DataTable/TableColumn';
import { TextColumn } from '../../components/DataTable/TextColumn';
import { DateColumn } from '../../components/DataTable/DateColumn';
import { Refund } from '../../interfaces/Refund/Refund';
import { refundStatusNameMap } from '../../interfaces/Refund/RefundStatus';
import { Pagination } from '../../interfaces/Pagination';
import { DataTable } from '../../components/DataTable/DataTable';

const columns: TableColumn<Refund>[] = [
  {
    id: 'user-name',
    name: 'Ad Soyad',
    accessor: (row) => (
      <TextColumn value={`${row.userFirstName} ${row.userLastName}`} />
    ),
  },
  {
    id: 'email',
    name: 'Email',
    accessor: (row) => <TextColumn value={row.email} />,
  },
  {
    id: 'product-name',
    name: 'Ürün Adı',
    accessor: (row) => <TextColumn value={row.productName} />,
  },
  {
    id: 'option-name',
    name: 'Varyant',
    accessor: (row) => <TextColumn value={row.optionName ?? ''} />,
  },
  {
    id: 'total-quantity',
    name: 'Ürün Adedi',
    accessor: (row) => <TextColumn value={row.quantity.toString()} />,
  },
  {
    id: 'status',
    name: 'Durum',
    accessor: (row) => <TextColumn value={refundStatusNameMap[row.status]} />,
  },
  {
    id: 'created-at',
    name: 'Oluşturulma Tarihi',
    accessor: (row) => <DateColumn value={row.createdAt} />,
  },
  {
    id: 'updated-at',
    name: 'Düzenlenme Tarihi',
    accessor: (row) => <DateColumn value={row.updatedAt} />,
  },
];

type RefundsTableProps = {
  refunds: Refund[];
  totalCount: number;
  pagination: Pagination;
  onPagination: (newPagination: Pagination) => void;
};

export const RefundsTable = (props: RefundsTableProps) => {
  const navigate = useNavigate();

  return (
    <DataTable
      columns={columns}
      totalCount={props.totalCount}
      rows={props.refunds}
      limit={props.pagination.pageSize}
      setLimit={(newLimit) =>
        props.onPagination({ page: 0, pageSize: newLimit })
      }
      page={props.pagination.page}
      setPage={(newPage) =>
        props.onPagination({ ...props.pagination, page: newPage })
      }
      onClick={(refund) => navigate(`/sales/refunds/${refund.id}`)}
    />
  );
};
